<template>
  <div class="dynamic-attr-text" :class="(attrObj.isCheckError?'is-check-error':'')">
    <div
      :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
      :style="{fontSize:$pScreen.titleS}"
    > 
      <!-- <span>{{attrObj.seqNumber+'.'}}</span> -->
      <span>{{ showNum(attrObj, currentPage) }} {{attrObj.title}}</span>
    </div>
    <div
      class="text-item-value"
      :style="{'margin-bottom': attrObj.isCheckError ? '0' : '15px'}"
    >
      <div class="textarea_value">
        <van-field
          @blur="blur"
          v-model="attrObj.answerContent"
          :disabled="attrObj.disabled"
          :placeholder="attrObj.desc"
          rows="3"
          autosize
          type="textarea"/>
      </div>
      <div v-if="attrObj.isCheckError" class="errorTip">{{attrObj.errorMsg || '请输入内容'}}</div>
    </div>
  </div>
</template>


<script>
import { FormType } from '../../../../commons/commonVariables.js';
import { Field } from 'vant';
export default {
  components:{
    [Field.name]: Field,
  },
  props: {
    attrObj: Object,
    currentPage: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      isArea: false,
      add: '',
    };
  },
  created() {},
  //初始化后调用
  mounted() {},
  methods: {
    blur() {
      if (this.attrObj.mustFlag=='1') {
        if (this.attrObj.answerContent && this.attrObj.answerContent.trim()) {
          this.$set(this.attrObj, "isCheckError", false);
        } else {
          this.$set(this.attrObj, "isCheckError", true);
        }
      }
    },
    // 只有趣味表单才展示题号
    showNum(item, current){
      if(item.formType !== FormType.interestForm){
        return ''
      } else {
        return `${current + 1}.`
      } 
    },
  }
};
</script>

<style lang="scss" scoped>
  .textarea_value {
    /deep/ .van-cell.van-field {
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      &:hover {
        border-color: #57a3f3;
      }
      &:focus {
          outline: 0;
          box-shadow: 0 0 0 2px rgba(45,140,240,.2);
      }
    }
  }
  .text-item-value {
    margin-top: 5px;
  }
  .van-cell.van-field {
    // padding: 15px 0;
  }
  .van-cell {
    background-color: #f8f8f8;
  }
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/textarea.vue